import YourLearning from '../../assets/htbd-images/YourLearning.png';
import wave from '../../assets/htbd-images/wave.png';
import circle from '../../assets/htbd-images/circle.png';
import YourUnderstanding from '../../assets/htbd-images/YourUnderstanding.png';
import SkilfulKnowledge from '../../assets/htbd-images/SkilfulKnowledge.png';
import SkillAcquisition from '../../assets/htbd-images/SkillAcquisition.png';

export default function Goal() {
  return (
    <section className="container-fluid p-5 position-relative" style={{ zIndex: '-2', backgroundColor: "#212239" }}>
      <div className="row justify-content-md-center g-5 align-items-top">
        <div className="col-lg-5 p-5 pt-0">
          <p className="text-white display-4">
            Goal to achieve through HTBD course
          </p>
          <p className="text-white">
            Understanding the placement of resource allocation by the Dubai
            government across the city, geographically.
          </p>
          <a href="#">See More</a>
          <span className="position-relative top-0 translate-middle-x" style={{ left: '50%', top: '5%'}}>
            <img src={circle} alt="circle" />
          </span>
          <span className="position-relative translate-middle-x" style={{ right: '45%', top: '35%'}}>
            <img src={wave} alt="wave" />
          </span>
        </div>
        <div className="col-lg-6">
          <div className="row row-cols-2 g-2">
            <div className="col-lg-4">
              <div className="p-1">
                <img className='pb-3' src={YourLearning}></img>
                <h3 style={{ color: "#f39322" }}>Your Learning</h3>
                <p className="text-white">
                  as a student, you will be able to take this learning to access
                  the resources laid out by The Dubai city and use them for
                  several purposes to make the best of you as a professional.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="p-1">
                <img className='pb-3' src={YourUnderstanding}></img>
                <h3 style={{ color: "#f39322" }}>Your Understanding</h3>
                <p className="text-white">
                  Students will understand the relevant resources available for
                  the community for ease of business, finding jobs, improving
                  lifestyle, demographics, and standard of living.
                </p>
              </div>
            </div>
          </div>
          <div className="row row-cols-2 g-2">
            <div className="col-lg-4">
              <div className="p-1">
                <img className='pb-3' src={SkilfulKnowledge}></img>
                <h3 style={{ color: "#f39322" }}>Skilful Knowledge</h3>
                <p className="text-white">
                  You’ll know about building start-ups in Dubai. Knowledge of
                  geopolitical resources, building a productive lifestyle, city
                  infrastructure, urban planning, & community development
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="p-1">
                <img className='pb-3' src={SkillAcquisition}></img>
                <h3 style={{ color: "#f39322" }}>Skill Acquisition:</h3>
                <p className="text-white">
                  Networking skills Start-up business skills Understanding
                  Arabic cultural skills
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
